import React from "react";
import { Chip } from "@mui/material";

export default function SessionStatusChip({ status }) {
  const value = String(status || "").toUpperCase();

  let sx = {
    fontWeight: 700,
    color: "#334155",
    bgcolor: "#e2e8f0",
    border: "1px solid #cbd5e1",
  };

  if (value === "ACTIVE") {
    sx = {
      fontWeight: 700,
      color: "#166534",
      bgcolor: "#dcfce7",
      border: "1px solid #86efac",
    };
  } else if (value === "PAUSED") {
    sx = {
      fontWeight: 700,
      color: "#92400e",
      bgcolor: "#fef3c7",
      border: "1px solid #fcd34d",
    };
  } else if (value === "STOPPED") {
    sx = {
      fontWeight: 700,
      color: "#991b1b",
      bgcolor: "#fee2e2",
      border: "1px solid #fca5a5",
    };
  } else if (value === "COMPLETED") {
    sx = {
      fontWeight: 700,
      color: "#1d4ed8",
      bgcolor: "#dbeafe",
      border: "1px solid #93c5fd",
    };
  }

  return <Chip label={status || "Unknown"} sx={sx} />;
}